<template>
  <b-modal
    :id="modalId"
    :ref="modalId"
    @ok="sendEmailApi"
    @shown="initializeModal"
    size="xl"
    :ok-title=" isSending ? 'Sending' : 'Send'"
    :ok-disabled="isSending"
    title="Email"
    scrollable
  >
    <div class="modal-body">
      <!-- <form id="sendEmailForm" enctype="multipart/form-data"> -->
      <b-row>
        <b-col cols="2" v-if="!hideAttachments">
          <b-form-group v-if="sendEmailData.reportSelectionOptions && sendEmailData.reportSelectionOptions.length > 0" class="scrollable">
            <template v-slot:label>
              <h6>Select the reports to include</h6>
            </template>
            <!-- <b-form-checkbox-group
              v-model="sendEmail.reports"
              :options="sendEmailData.reportSelectionOptions"
              value-field="fileName"
              stacked
              disabled-field="defaultSelected"
            ></b-form-checkbox-group> -->
            <b-form-checkbox-group
              v-model="sendEmail.reports"
              :options="sendEmailData.reportSelectionOptions"
              value-field="report"
              text-field="display"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
          <br/>
          <b-button size="sm" variant="primary"
          @click="onReportAction"
          :disabled="!isShowEmailForm ? false : sendEmail.reports.length == 0" class="mr-2">
            {{ isShowEmailForm ? 'Preview' : 'Back to Email Form' }}
          </b-button>
          <b-button size="sm ml-2" variant="primary"
          @click="onGenerateReport" v-show="!isShowEmailForm"
          :disabled="sendEmail.reports.length == 0" class="mr-2"> Preview

          </b-button>
          <!-- <b-button size="sm" variant="primary" @click="onPreview" :disabled="sendEmail.reports.length == 0"> Preview</b-button> -->
          <hr/>
          <b-form-group v-if="sendEmailData.documentsSelection && sendEmailData.documentsSelection.length > 0" class="scrollable">
            <template v-slot:label>
              <h6>Select the documents to include</h6>
            </template>
            <b-form-checkbox-group
              v-model="sendEmail.documents"
              :options="sendEmailData.documentsSelection"
              value-field="guid"
              text-field="filename"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
          <b-form-group v-else-if="!sendEmailData.documentsSelection && !sendEmailData.reportSelectionOptions ">
            <template v-slot:label>
              <h6>No attachments available</h6>
            </template>
          </b-form-group>
        </b-col>
        <b-col cols="10" v-if="!isShowEmailForm && !hideAttachments">
          <iframe height="700" width="1200" :src="generateReport"></iframe>
        </b-col>
        <!-- <b-col :cols="sendEmailData.isMultipleAttachment ? '10' : '12'"> -->
        <b-col :cols="hideAttachments ? '12' : '10'" v-if="isShowEmailForm">
          <b-form-group label-cols="1" label-align="right" class="mb-2" label="From:">
            <div style="margin-top: 6px;">
              {{ user.name }} - {{ user.username }}  
            </div>
            
          </b-form-group>
          <b-form-group label-cols="1" label-align="right" class="mt-1" label="Template:">
            <b-form-select v-model="templateUsed" @change="updateContent">
              <option v-for="(select, index) in sortSelect(emailTemplates,'name')" :key="index" :value="select">
                {{ select.name }}
              </option>
            </b-form-select>
          </b-form-group>
          <b-form-group label-cols="1" label-align="right" class="mt-1 required" label="To:">
            <b-form-input
              v-model.trim="sendEmail.to"
              @blur="$v.sendEmail.to.$touch()"
              :class="{ 'is-invalid': $v.sendEmail.to.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>Please enter valid email</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label-cols="1" label-align="right" class="mt-1" label="Cc:">
            <b-form-input
              v-model.trim="sendEmail.cc"
              @blur="$v.sendEmail.cc.$touch()"
              :class="{ 'is-invalid': $v.sendEmail.cc.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>Please enter valid email</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label-cols="1" label-align="right" class="mt-1" label="Bcc:">
            <b-form-input
              v-model.trim="sendEmail.bcc"
              @blur="$v.sendEmail.bcc.$touch()"
              :class="{ 'is-invalid': $v.sendEmail.bcc.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>Please enter valid email</b-form-invalid-feedback>
          </b-form-group>

          <b-form-group label-cols="1" label-align="right" class="mt-1" label="Attach: ">
            <b-form-file
              multiple
              :file-name-formatter="formatNames"
              :placeholder="attachmentPlaceholder"
              v-model="sendEmail.uploadedAttachments"
              :accept="fileTypes"
            ></b-form-file>
          </b-form-group>

          <b-form-group label-cols="1" label-align="right" class="mt-1 required" label="Subject:">
            <b-form-input
              v-model.trim="sendEmail.subject"
              @blur="$v.sendEmail.subject.$touch()"
              :class="{ 'is-invalid': $v.sendEmail.subject.$error }"
            ></b-form-input>
            <b-form-invalid-feedback>Please enter subject</b-form-invalid-feedback>
          </b-form-group>
          <b-form-group label="Message:" class="mt-2 required">
            <vue-editor v-model.trim="sendEmail.body"
              @blur="$v.sendEmail.body.$touch()"
              :class="{ 'is-invalid': $v.sendEmail.body.$error }"></vue-editor>
            <!-- <b-form-textarea
              rows="30"
              v-model.trim="sendEmail.body"
              @blur="$v.sendEmail.body.$touch()"
              :class="{ 'is-invalid': $v.sendEmail.body.$error }"
            ></b-form-textarea> -->
            <b-form-invalid-feedback>Please enter message</b-form-invalid-feedback>
          </b-form-group>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';
import debounce from 'lodash/debounce';
import service from './service';
import { VueEditor } from "vue2-editor";
import { required, email } from 'vuelidate/lib/validators';
import { multiEmailValidator } from '@/shared/validators';
import { SEND_EMAIL_IDS } from '@/shared/constants';
export default {
  props: {
    sendEmailData:{ type: Object, default: () => {} },
    modalId: { type: String, default: 'send-email-modal' },
    isMultipleSend: { type: Boolean, default: false },
    multipleRecipients: {type: Array, default: () => []}, // contains an array of object with Reference Id and email (See RFP on Send EMail)
    defaultReports: {type: Array, default: () => []},
    hideAttachments: {type: Boolean, default: false}
  },
  data() {
    return {
      sendEmail: {
        to: this.sendEmailData.to || '',
        subject: '',
        cc: '',
        bcc: '',
        body: '',
        uploadedAttachments: [],
        //serverDocumentIds: [0],
        dateSent: new Date().toISOString(),
        SourceId:'',
        ReferenceId:'',
        reports: [],
        documents: []
      },
      categoryTemplates: [],
      isSending: false,
      isShowEmailForm: true,
      generateReport: null,
      templateUsed: null,
      fileTypes: [
        '.txt',
        '.pdf',
        '.doc',
        '.docx',
        '.xls',
        '.xlsx',
        '.png',
        '.jpg',
        '.jpeg',
        '.gif',
        '.csv',
        '.ppt',
        '.pptx',
      ].join(', '),
    };
  },
  components:{
    VueEditor
  },
  validations: {
    sendEmail: {
      to: {
        required,
        multiEmailValidator,
      },
      cc: {
        multiEmailValidator,
      },
      bcc: {
        multiEmailValidator,
      },
      subject: {
        required,
      },
      body: {
        required,
      },
    },
  },
  computed: {
    ...mapState('account', ['user']),
    ...mapGetters('lookup', ['emailTemplates', 'emailSources']),
    attachmentPlaceholder() {
      let name = ``;

      if (this.sendEmail.reports.length > 0) {
        name += `${this.sendEmailData.template} - ${this.sendEmailData.ReferenceId}.pdf; `;
      } else {
        name = `No attachment selected`;
      }

      return name;
    }
  },
  methods: {
    updateContent(val){
      if (val) {
        // const myData = this.categoryTemplates.find(obj => {
        //   return (obj.id == val);
        // });
        // if(myData){
        //   this.sendEmail.body = myData.body
        //   this.sendEmail.subject = myData.subject
        // }
        if (val.toRecipients)
          this.sendEmail.to = (this.sendEmail.to) ? this.sendEmail.to + '; ' + val.toRecipients : val.toRecipients;
        if (val.ccRecipients) 
          this.sendEmail.cc = (this.sendEmail.cc) ? this.sendEmail.cc + '; ' + val.ccRecipients : val.ccRecipients;
        if (val.bccRecipients)
          this.sendEmail.bcc = (this.sendEmail.bcc) ? this.sendEmail.bcc + '; ' + val.bccRecipients : val.bccRecipients;

        this.sendEmail.subject = val.subject;
        this.sendEmail.body = val.body;
      }
    },
    async initializeModal() {
      this.categoryTemplates = [];
      this.isShowEmailForm = true;
      this.$v.sendEmail.$reset();

      let sourceId = 0;
      if (this.sendEmailData.source) {
        let srcNdx = this.emailSources.findIndex(x => x.name == this.sendEmailData.source);
        if (srcNdx > -1)
          sourceId = this.emailSources[srcNdx].id;
      }

      this.sendEmail.SourceId = sourceId;
      this.sendEmail.to = this.sendEmailData.to;
      this.sendEmail.ReferenceId=this.sendEmailData.ReferenceId;
      this.sendEmail.reports = [];
      this.sendEmail.documents = [];

      if (this.sendEmailData.bcc) {
        this.sendEmail.bcc = this.sendEmailData.bcc;
      }

      // let templateId = (this.sendEmailData.template) ? SEND_EMAIL_IDS[this.sendEmailData.template].templateId : 0;
      // if(templateId>0){
      //   const result = await service.getEmailTemplate(templateId);
      //   if(result){
      //     this.sendEmail.subject = result.subject
      //     this.sendEmail.body = result.body
      //     if(result.emailTemplateCategoryId){
      //       this.categoryTemplates = await service.getEmailTemplatesbycategory(result.emailTemplateCategoryId);
      //     }
      //     if (this.defaultReports.length > 0) {
      //       for (let i = 0; i < this.defaultReports.length; i++) {
      //         this.sendEmail.reports.push(this.defaultReports[i]);
      //       }
      //     }
      //   }
      // } else if (this.sendEmailData.subject || this.sendEmailData.body) {
      //   this.sendEmail.subject = this.sendEmailData.subject;
      //   this.sendEmail.body = this.sendEmailData.body;
      // }

      if (this.sendEmailData.subject || this.sendEmailData.body) {
        this.sendEmail.subject = this.sendEmailData.subject;
        this.sendEmail.body = this.sendEmailData.body;
      } else if (this.sendEmailData.source) {
        let templateNdx = this.emailTemplates.findIndex(x => x.name == this.sendEmailData.source);

        if (templateNdx > -1) {
          this.templateUsed = this.emailTemplates[templateNdx];
          this.updateContent(this.emailTemplates[templateNdx]);
        }
      }

      if (this.defaultReports.length > 0) {
          for (let i = 0; i < this.defaultReports.length; i++) {
            this.sendEmail.reports.push(this.defaultReports[i]);
          }
        }
    },
    sendEmailApi: async function(e) {
      this.$v.sendEmail.$touch();
      if (this.$v.sendEmail.$invalid) {
        e.preventDefault();
        return;
      }

      try {
        this.isSending = true;

        let formData = new FormData();
        formData.append('from', this.user.username);
        for (const property in this.sendEmail) {
          if (property == 'uploadedAttachments' && this.sendEmail.uploadedAttachments.length > 0) {
            this.sendEmail.uploadedAttachments.forEach(element => {
              formData.append('uploadedAttachments[]', element, element.name);
            });
          } else if (property == 'reports' && this.sendEmail.reports.length > 0) {
            this.sendEmail.reports.forEach(element => {
              formData.append('reports[]', element);
            });
          } else if (property == 'documents' && this.sendEmail.documents.length > 0) {
            this.sendEmail.documents.forEach(element => {
              formData.append('documents[]', element);
            });
          } else {
            formData.append(property, this.sendEmail[property]);
          }
        }
        /*for (var pair of formData.entries()) {
          console.log(pair[0]+ ', ' + pair[1]);
      }*/
        var result = null;
        e.preventDefault();
        if (this.isMultipleSend) {
          const bccField = this.sendEmail.bcc.split(";").map(i => i.trim());
          for (let i = 0; i < bccField.length; i++) {
            if (formData.has('bcc'))
              formData.delete('bcc');
            if (formData.has('ReferenceId'))
              formData.delete('ReferenceId');

            let recipient = this.multipleRecipients.find(x=> x.email == bccField[i]);
            formData.append('bcc', bccField[i]);
            if (recipient != undefined)
              formData.append('ReferenceId', recipient.id);
            result = await service.createWithReq(formData);
          }
          
        } else {
          result = await service.createWithReq(formData);
        }

        
        this.isSending = false;

        if (result) {
          this.$v.sendEmail.$reset();
          this.$root.$emit('bv::hide::modal', this.modalId);
          this.$emit('refresh');
          this.$emit('emailSendRequest', result);
        }
      }catch (e) {
        this.isSending = false;
      }
    },
    formatNames(files) {
      let name = ``;
      if (files.length > 1) {
        let filesCount = files.length;
        if (this.sendEmail.reports.length > 0) { filesCount += 1 }
        name = `${filesCount} files selected`;
      }
      else {
        if (this.sendEmail.reports.length > 0) {
          name += `${this.sendEmailData.template} - ${this.sendEmailData.ReferenceId}.pdf; `;
        }
        if (files.length === 1) {
          name += `${files[0].name};`;
        }
      }
      return name;
    },
    onGenerateReport() {
      let url = ``;
      this.generateReport = null;

      for (let i = 0; i < this.sendEmail.reports.length; i++) {
        url += `reports=${this.sendEmail.reports[i]}&`;
      }

      url += `paramValue=${(this.isMultipleSend && this.multipleRecipients.length > 0) ? this.multipleRecipients[0].id : this.sendEmail.ReferenceId }`;

      this.generateReport = (this.sendEmail.reports.length > 0) ? process.env.VUE_APP_API_URL + 'DisplayReport?' + url : null;
    },
    onReportAction() {
      if (this.isShowEmailForm) {
        this.onGenerateReport();
        this.isShowEmailForm = false;
      } else {
        this.isShowEmailForm = true;
      }
    }
  },
  mounted() {
    this.$v.sendEmail.$reset();
  },
};
</script>

<style lang="scss">
.quillWrapper.is-invalid ~ .invalid-feedback{display: block;}
.scrollable {
  max-height: 300px;
  overflow-x: auto;
  overflow-y: auto;
}

</style>
